import { createReducer, on } from '@ngrx/store';
import * as DashboardActions from './dashboard.actions';
import { DashboardState, initialDashboardState } from './dashboard.state';

export const dashboardReducer = createReducer(
  initialDashboardState,
  on(DashboardActions.loadDashboardOverview, (state): DashboardState => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(DashboardActions.loadDashboardOverviewSuccess, (state, { overview }): DashboardState => ({
    ...state,
    overview,
    loading: false,
  })),
  on(DashboardActions.loadDashboardOverviewFailure, (state, { error }): DashboardState => ({
    ...state,
    loading: false,
    error,
  })),
  on(DashboardActions.loadEventStats, (state): DashboardState => ({
    ...state,
    eventStatsLoading: true,
    eventStatsError: null,
  })),
  on(DashboardActions.loadEventStatsSuccess, (state, { stats }): DashboardState => ({
    ...state,
    eventStats: stats,
    eventStatsLoading: false,
  })),
  on(DashboardActions.loadEventStatsFailure, (state, { error }): DashboardState => ({
    ...state,
    eventStatsLoading: false,
    eventStatsError: error,
  })),
  on(DashboardActions.loadUserStats, (state): DashboardState => ({
    ...state,
    userStatsLoading: true,
    userStatsError: null,
  })),
  on(DashboardActions.loadUserStatsSuccess, (state, { stats }): DashboardState => ({
    ...state,
    userStats: stats,
    userStatsLoading: false,
  })),
  on(DashboardActions.loadUserStatsFailure, (state, { error }): DashboardState => ({
    ...state,
    userStatsLoading: false,
    userStatsError: error,
  })),
  on(DashboardActions.loadVolunteerStats, (state): DashboardState => ({
    ...state,
    volunteerStatsLoading: true,
    volunteerStatsError: null,
  })),
  on(DashboardActions.loadVolunteerStatsSuccess, (state, { stats }): DashboardState => ({
    ...state,
    volunteerStats: stats,
    volunteerStatsLoading: false,
  })),
  on(DashboardActions.loadVolunteerStatsFailure, (state, { error }): DashboardState => ({
    ...state,
    volunteerStatsLoading: false,
    volunteerStatsError: error,
  })),
  on(DashboardActions.resetDashboardState, (): DashboardState => ({
    ...initialDashboardState,
  })),
);
